import FocusableBackButton from '@components/FocusableBackButton';
import { usePaymentSelectionContext } from '@context/Payment/PaymentSelection';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import PaymentButtons from './components/PaymentButtons';

import * as styles from './styles';

const PaymentSelectionView = () => {
  const { goBack } = usePaymentSelectionContext();

  const { ref, focusKey } = useFocusable();

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} css={styles.container}>
        <div css={styles.leftSideContainer}>
          <FocusableBackButton onEnterPress={goBack} />
          <p css={styles.title}>결제수단을 선택해주세요</p>
        </div>
        <div css={styles.rightSideContainer}>
          <PaymentButtons />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default PaymentSelectionView;
